import { Trigger } from '@radix-ui/react-hover-card'

export const HoverCardTrigger = Trigger
